import { render } from "./CustomerCompanyPage.vue?vue&type=template&id=7e2f91ac"
import script from "./CustomerCompanyPage.vue?vue&type=script&lang=js"
export * from "./CustomerCompanyPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__